import styled, {
  css,
  DefaultTheme,
  FlattenInterpolation,
  FlattenSimpleInterpolation,
  ThemeProps
} from 'styled-components';
import Text from '@text';
import styleUtils from '../../../../styles/style.utils';
import themedColor from '../../../../styles/theme/themed-color';
import themedFontSize from '../../../../styles/theme/themed-font-size';
import mediaBreakpoints from '../../../../styles/media-breakpoints';

const Container = styled.div`
  transition: all 1s;
  width: 100%;
  overflow: hidden;
  border: 1px solid ${themedColor('GRAY')};
  border-bottom: none;
  &:last-child {
    border-bottom: 1px solid ${themedColor('GRAY')};
  }
`;

const Inactive = css`
  filter: grayscale(100%) opacity(35%);
`;

interface AccordionButtonProps {
  isGreyed: boolean;
}
const AccordionButton = styled.div<AccordionButtonProps>`
  ${({
    isGreyed
  }: AccordionButtonProps): FlattenSimpleInterpolation | undefined =>
    isGreyed ? Inactive : undefined}

  min-height: ${styleUtils.size('MOBILE_REDIRECT_BUTTON_HEIGHT')};
  display: flex;
  align-items: center;
  padding: ${styleUtils.px(8)};
  font-size: ${themedFontSize('MOBILE_REDIRECT_BUTTON')};
  width: 100%;
  color: ${themedColor('TEXT_BLUE')};

  ${mediaBreakpoints.greaterThan('XXS')`
    padding: ${styleUtils.px(16)};
  `};
`;

const ButtonIcon = styled.img`
  max-height: ${styleUtils.px(32)};
  margin-right: ${styleUtils.px(4)};

  ${mediaBreakpoints.greaterThan('XXS')`
    max-height: ${styleUtils.px(40)};
    margin-right: ${styleUtils.px(14)};
  `};
`;

const ActiveButton = css`
  font-weight: 700;
  text-decoration: underline;
`;

interface ButtonTextProps {
  isActive: boolean;
}

const ButtonText = styled(Text)<ButtonTextProps>`
  ${({ isActive }: ButtonTextProps): FlattenSimpleInterpolation | false =>
    isActive && ActiveButton};
  font-size: ${themedFontSize('MOBILE_REDIRECT_BUTTON_XS')};
  margin-bottom: 0;

  ${mediaBreakpoints.greaterThan('XS')`
    font-size: ${themedFontSize('MOBILE_REDIRECT_BUTTON')};
  `};
`;

interface AccordionBodyProps {
  isActive: boolean;
  contentHeight: number;
}

const AccordionBody = styled.div<AccordionBodyProps>`
  max-width: 100%;
  transition: height 0.3s;

  height: ${({ isActive, contentHeight }: AccordionBodyProps): string =>
    isActive ? ` ${contentHeight}px` : `0`};
`;

const AccordionContent = styled.div`
  background: ${themedColor('GRAY')};
  height: auto;
  padding: ${styleUtils.px(16)};
  display: flex;
  align-items: center;
  min-height: ${styleUtils.size('MOBILE_REDIRECT_BUTTON_HEIGHT')};
`;

const ContentText = styled(Text)`
  &.ucf-paragraph {
    padding-right: ${styleUtils.px(10)};
    color: ${themedColor('TEXT_BLUE')};
    font-size: ${themedFontSize('MOBILE_REDIRECT_BUTTON')};
    margin-bottom: 0;
    max-width: calc(100% - 30px);
    font-weight: 400;
  }
`;

const ArrowStyles = css`
  width: ${styleUtils.px(8)};
  height: ${styleUtils.px(8)};
  border-right: ${styleUtils.px(2)} solid ${themedColor('TEXT_BLUE')};
  border-top: ${styleUtils.px(2)} solid ${themedColor('TEXT_BLUE')};
  margin-left: auto;
  ${mediaBreakpoints.greaterThan('XXS')`
    width: ${styleUtils.px(16)};
    height: ${styleUtils.px(16)};
  `};
`;

const ContentArrow = styled.div`
  ${ArrowStyles};
  transform: rotate(45deg) translate(-2px, 2px);

  ${mediaBreakpoints.greaterThan('XXS')`
    transform: rotate(45deg) translate(-4px, 4px);
  `};
`;

const ActiveArrow = css`
  transform: rotate(-45deg);
  border-color: ${themedColor('TEXT_DISABLED')};
`;

const InactiveArrow = css`
  transform: rotate(135deg);
`;

interface ArrowProps {
  isActive: boolean;
}

const Arrow = styled.div<ArrowProps>`
  ${ArrowStyles};

  ${({
    isActive
  }: ArrowProps): FlattenInterpolation<ThemeProps<DefaultTheme>> =>
    isActive ? ActiveArrow : InactiveArrow};
`;

const MobileButtonsListItemComponents = {
  Container,
  AccordionButton,
  ButtonIcon,
  ButtonText,
  Arrow,
  AccordionBody,
  AccordionContent,
  ContentText,
  ContentArrow
};

export default MobileButtonsListItemComponents;
